import React, { useContext } from 'react';
import { Form, Formik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as Yup from 'yup';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { growlActionSuccess, growlErrors } from '../../../../utils/NotificationUtil';
import { useMutation } from '@apollo/react-hooks';
import FileDropzone from '../../../../components/file-dropzone/FileDropzone';
import { UPDATE_DOCUMENT_CONTENT_MUTATION } from '../services/document-management.service';

const UpdateDocumentContentDialog = ({
  documentId,
  documentType,
  documentVersion,
  showUpdateDocumentContentDialog,
  hideUpdateDocumentContentDialog,
}) => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const [updateDocumentContent] = useMutation(UPDATE_DOCUMENT_CONTENT_MUTATION);

  const updateContent = async ({ file }) => {
    try {
      await updateDocumentContent({
        variables: {
          input: {
            accountId: currentAccount,
            documentId,
            fieldName: '1',
            type: documentType,
          },
          file,
        },
        refetchQueries: ['documentListQuery'],
      });

      hideUpdateDocumentContentDialog();
      growlActionSuccess(growl);
    } catch (mutationError) {
      growlErrors(growl, mutationError);
    }
  };

  const initialValues = {
    file: null,
  };

  const validationSchema = Yup.object().shape({
    file: Yup.mixed().required(),
  });

  return (
    <Dialog
      header={`Update document for version ${documentVersion}`}
      visible={showUpdateDocumentContentDialog}
      onHide={hideUpdateDocumentContentDialog}
      style={{
        maxWidth: '25%',
      }}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => updateContent(values)}
      >
        {({ isValid, isSubmitting, handleSubmit }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <div className="p-col-12 center">
                <p>Upload a new version of the document</p>
                <FileDropzone />

                <br />
                <div className="align-center">
                  <Button
                    type="button"
                    className="p-button-secondary"
                    onClick={hideUpdateDocumentContentDialog}
                    disabled={isSubmitting}
                    label="Cancel"
                  />
                  <Button type="submit" disabled={!isValid || isSubmitting} label="Save" />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};

export default UpdateDocumentContentDialog;
